import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { messages as modalMessages } from 'ui-components/components/modal/messages';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { FlexColumn } from 'ui-components/components/flex';

import { SimpleModal } from '../../components/simple-modal/simple-modal';
import { messages } from './messages';
import { emptyObject } from 'ui-components/default-props/empty';
import { reshipFulfillmentPlan } from './reship.api';
import { useEntitiesSalesOrder } from '../../hooks/entities/selectors/sales-orders';

import style from './reship-modal.module.less';

export const ReshipModal = ({ salesOrderId, fulfillmentPlanId, onSuccess, onClose, onError }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const { fulfillmentPlanIds = [], orderNumber } = useEntitiesSalesOrder(salesOrderId) || emptyObject;

  const newShipmentCount = fulfillmentPlanIds.length + 1;

  const reship = useCallback(() => {
    setIsLoading(true);
    setHasError(false);

    reshipFulfillmentPlan({
      salesOrderId,
      fulfillmentPlanId,
    })
      .then((response) => {
        onSuccess(response.data?.fulfillmentPlanId);
      })
      .catch((error) => {
        onError({ error });
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [fulfillmentPlanId, onSuccess, salesOrderId, onError]);

  return (
    <SimpleModal
      actionMessage={messages.reshipButton}
      cancelMessage={modalMessages.modalCancel}
      headerMessage={messages.reshipModalHeader}
      isActionDisabled={isLoading}
      onAction={reship}
      onCancel={onClose}
      onClose={onClose}
      size='medium'
    >
      <FlexColumn className={style['reship-modal-content']}>
        {hasError && (
          <BannerMessageV2
            content={<Text textType={TextType.Paragraph} value={messages.reshipModalErrorMessage} />}
            layout={BannerLayout.Inline}
            status={BannerStatus.Error}
          />
        )}
        {isLoading ? (
          <LoadingIndicator className={style['loading-indicator']} />
        ) : (
          <div>
            <Text
              formattedMessageValues={{
                orderNumber,
                shipmentNumber: newShipmentCount,
                shipmentCount: newShipmentCount,
              }}
              textType={TextType.Paragraph}
              value={messages.reshipModalContentLine1}
            />
            <Text textType={TextType.Paragraph} value={messages.reshipModalContentLine2} />
          </div>
        )}
      </FlexColumn>
    </SimpleModal>
  );
};

ReshipModal.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
